import { useEffect, useRef } from "react";
import { useState } from "react";
import { Button, InputGroup, Form } from "react-bootstrap";
import { AnimatedIconButton } from "../AnimatedIconButton/AnimatedIconButton";
export function EmailInput({
                               inputValue = "",
                                maxCount,
                               parentCallback,
                               placeholder,
                               required = false,
                           }) {
    const [emails, setEmails] = useState([{ key: 0, value: "" }]);
    const [emailsValid, setEmailsValid] = useState(false);
    const inputRefs = useRef([]);
    const [validationMsg, setValidationMsg] = useState([]);
    const btnStyle = {
        margin: 0,
        borderRadius: "0rem 0.25rem 0.25rem 0rem",
    };
    const requiredInputStyle = required ? { borderLeft: "3px solid red" } : {};

    useEffect(() => {
        if (emails && emailsValid) {
            parentCallback(emails.map((e) => e.value).join(","));
        }
    }, [emails]);

    useEffect(() => {
        if (inputValue && inputValue !== -1) {
            let initialValues = inputValue.split(",");
            const emailArray = initialValues.map((e, i) => {
                return {
                    key: i,
                    value: e,
                };
            });
            setEmails(emailArray);
        }
        if (inputValue === -1) {
            setEmails([{ key: 0, value: "" }]);
        }
    }, [inputValue]);

    function addNewTextBox(e, idx) {
        if(emails.length >= maxCount){
            return;
        }
        let lastEmail = emails.at(-1);
        setEmails([...emails, { key: lastEmail.key + 1, value: "" }]);
    }

    function removeEmail(key) {
        let filteredEmails = emails.filter((email) => {
            return email.key !== key;
        });
        if (filteredEmails.length === 0) {
            filteredEmails = [
                {
                    key: 0,
                    value: "",
                },
            ];
        }
        setEmails(filteredEmails);
        let emailsString = filteredEmails.map((e) => e.value).join(",");
        parentCallback(emailsString);
    }

    function updateEmail(email) {
        const regExp = /^[a-zA-Z0-9._%+&-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
        const newEmails = emails.map((e) => {
            return e.key === email.key ? email : e;
        });
        setEmails(newEmails);

        if (regExp.test(email.value)) {
            const filteredVal = validationMsg.filter((val) => {
                return val.key !== email.key;
            });
            setValidationMsg(filteredVal);

            setEmailsValid(true);
        } else {
            const previousMsg = [...validationMsg];
            let msg = { key: email.key, msg: "Correo Electrónico no válido." };
            setValidationMsg([...previousMsg, msg]);
        }
    }

    useEffect(() => {
        if (emails.length && emails.length > 1) {
            inputRefs.current[emails.length - 1]?.focus();
        }
    }, [emails.length]);

    return (
        <>
            {emails.map((email, idx) => {
                return (
                    <div
                        className="mb-1"
                        key={email.key}
                        style={{
                            width: "102%",
                        }}
                    >
                        <InputGroup>
                            <Form.Control
                                ref={(el) => (inputRefs.current[idx] = el)}
                                name="Email"
                                type="email"
                                autoFocus ={idx > 0}
                                placeholder={placeholder ? placeholder : ""}
                                value={email.value}
                                onChange={(e) =>
                                    updateEmail({ key: email.key, value: e.target.value })
                                }
                                onBlur={(e) =>
                                    updateEmail({ key: email.key, value: e.target.value })
                                }
                                style={requiredInputStyle}
                            />
                            {idx >= 1 ? (
                                <AnimatedIconButton
                                    size="40px"
                                    height="18"
                                    width="18"
                                    style={{
                                        borderRadius: "0%",
                                        paddingLeft: "0px",
                                        marginLeft: "0px",
                                        paddingTop: "0px",
                                        paddingRight: "0px",
                                        marginRight: "-1px",
                                    }}
                                    useVendorTheme
                                    iconName="minus"
                                    onClick={() => removeEmail(email.key)}
                                />
                            ) : null}
                            {(maxCount !== 1) && (
                                <AnimatedIconButton
                                    size="40px"
                                    height="18"
                                    width="18"
                                    useVendorTheme
                                    style={{
                                        borderRadius: "0% 0.3rem 0.3rem 0%",
                                        paddingLeft: "0px",
                                        marginLeft: "0px",
                                        paddingTop: "0px",
                                    }}
                                    iconName="plus"
                                    onClick={(e) => addNewTextBox(e, idx)}
                                />  
                            )}
                        </InputGroup>
                        {validationMsg !== [] &&
                        validationMsg.find((val) => val.key === email.key) !== undefined ? (
                            <Form.Text className="text-danger" id="validationMsg" muted>
                                {validationMsg.find((val) => val.key === email.key).msg}
                            </Form.Text>
                        ) : null}
                    </div>
                );
            })}
        </>
    );
}
